import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import {classesIP} from '../selectedPersonaStyles'
import {classes, StyledDivider} from '../../PersonaSummary/SummaryComponentStyles'

const OverviewDesc = ({filteredPersonaDesc, handlePersonaCustomLabel}) => {
  const [viewMore, setViewMore] = React.useState(true)

  return (
    <>
      <Typography className={classesIP.personaSubTitle} tabIndex={0}>
        {handlePersonaCustomLabel('overview', 'WHO WE ARE')}
      </Typography>

      <Typography className={classesIP.personaParagraph} tabIndex={0}>
        {viewMore ? filteredPersonaDesc[0]?.descS : filteredPersonaDesc[0]?.descL} {viewMore && '...'}
      </Typography>
      <Stack
        direction="row"
        className={[classes.summaryTitleColorTeal, classesIP.overviewStack]}
        gap={1}
        onClick={() => setViewMore(!viewMore)}
        onKeyDown={(e) => e.key === 'Enter' && setViewMore(!viewMore)}
        tabIndex={0}
      >
        {viewMore ? (
          <>
            <ExpandMoreIcon className={classesIP.overviewIcons} />
            <Typography>View More</Typography>
          </>
        ) : (
          <>
            <ExpandLessIcon className={classesIP.overviewIcons} />
            <Typography>View Less</Typography>
          </>
        )}
      </Stack>
      <StyledDivider />
    </>
  )
}
OverviewDesc.propTypes = {
  filteredPersonaDesc: PropTypes.array.isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default OverviewDesc
